;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockOverflowCarousel from './BlockOverflowCarousel';

const query = /* GraphQL */ `
    ${ctaFragment}
    ${linkFragment}
    ${assetFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockOverflowCarousel(preview: $preview, id: $id) {
            __typename
            anchorId
            flushTop
            flushBottom
            extendedTopPadding
            slidesCollection {
                items {
                    __typename
                    ... on BlockOverflowCarouselOverflowSlide {
                        eyebrow
                        headline {
                            json
                        }
                        image {
                            ...Asset
                        }
                        imageAnimationOrigin
                        cta {
                            ... on Cta {
                                ...CTA
                            }
                        }
                        backgroundColor
                    }
                    ... on BlockOverflowCarouselContainedSlide {
                        eyebrow
                        headline {
                            json
                        }
                        image {
                            ...Asset
                        }
                        cta {
                            ... on Cta {
                                ...CTA
                            }
                        }
                        backgroundColor
                    }
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockOverflowCarousel },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockOverflowCarousel;
}

const BlockOverflowCarouselServer = async ({ id, firstBlock }) => {
    const block = await fetchBlock(id);
    return (
        <BlockOverflowCarousel
            {...block}
            firstBlock={firstBlock}
            slides={block.slidesCollection.items}
        />
    );
};

export default BlockOverflowCarouselServer;
